export const environment = {
  production: false,
  baseBackendUrl: 'https://reporting.dev.mojito360.com/backend'
  // baseBackendUrl: 'http://localhost:5003',
};
